const TIMEZONE_STORAGE_KEY = 'dealos.timezone';

function isValidTimezone(tz: string): boolean {
  try {
    Intl.DateTimeFormat(undefined, { timeZone: tz });
    return true;
  } catch {
    return false;
  }
}

export function getConfiguredTimezone(): string {
  try {
    const stored = localStorage.getItem(TIMEZONE_STORAGE_KEY);
    if (stored && isValidTimezone(stored)) return stored;
  } catch {
    // localStorage may be unavailable
  }
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function setConfiguredTimezone(timezone: string): void {
  try {
    localStorage.setItem(TIMEZONE_STORAGE_KEY, timezone);
  } catch {
    // localStorage may be unavailable
  }
}

export function clearConfiguredTimezone(): void {
  try {
    localStorage.removeItem(TIMEZONE_STORAGE_KEY);
  } catch {
    // localStorage may be unavailable
  }
}

export function getBrowserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function getTimezoneAbbreviation(): string {
  const timezone = getConfiguredTimezone();
  try {
    const parts = new Intl.DateTimeFormat(undefined, { timeZone: timezone, timeZoneName: 'short' }).formatToParts(new Date());
    return parts.find(p => p.type === 'timeZoneName')?.value || timezone;
  } catch {
    return timezone;
  }
}

export function formatDate(dateString: string): string {
  const timezone = getConfiguredTimezone();
  try {
    return new Date(dateString).toLocaleString(undefined, {
      timeZone: timezone,
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  } catch {
    return new Date(dateString).toLocaleString();
  }
}

export function formatDateWithZone(dateString: string): string {
  return `${formatDate(dateString)} (${getTimezoneAbbreviation()})`;
}

export function getAvailableTimezones(): string[] {
  try {
    // supportedValuesOf is available in all modern browsers but not in older TS lib targets
    return (Intl as unknown as { supportedValuesOf(key: string): string[] }).supportedValuesOf('timeZone');
  } catch {
    return [getBrowserTimezone()];
  }
}
